import firebase from 'firebase'

// Your web app's Firebase configuration
var firebaseConfig = {
	apiKey            : "AIzaSyAN6_9W7h_PkM4iIrvFnUIZ7XWbMpVAh4E",
	authDomain        : "old-beauty.firebaseapp.com",
	projectId         : "old-beauty",
	storageBucket     : "old-beauty.appspot.com",
	messagingSenderId : "535220809940",
	appId             : "1:535220809940:web:5060c0b41c0b2d2a608b41"
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export default firebase
